<ion-app [class.dark-theme]="dark">
  <ion-router-outlet id="principal"></ion-router-outlet>
  <app-menu></app-menu>
</ion-app>